module.exports = __webpack_public_path__ + "img/language-hoovering.e7a07f50.svg";